import React from "react";
import PropTypes from "prop-types";

import { assertNonEmptyString, assertOneOf } from "../../internal/contracts";
import { useThemeA } from "../../internal/ThemeAContext";
import {
  BUTTON_ICON_CLASS,
  BUTTON_LABEL_CLASS,
  BUTTON_SPINNER_CLASS,
  buttonClassName,
} from "./buttonStyles";

const INTENTS = ["primary", "secondary", "quiet", "destructive"];

export function Button({
  children,
  className = "",
  disabled = false,
  form,
  icon = null,
  intent = "primary",
  loading = false,
  loadingLabel,
  onClick,
  title,
  type = "button",
}) {
  useThemeA("Button");
  assertOneOf("Button", "intent", intent, INTENTS);
  if (loading) {
    assertNonEmptyString("Button", "loadingLabel", loadingLabel);
  }
  const unavailable = disabled || loading;

  return (
    <button
      data-ak-v2-intent={intent}
      type={type}
      className={`${buttonClassName(intent)} ${className}`.trim()}
      disabled={unavailable}
      form={form}
      aria-busy={loading || undefined}
      aria-label={loading ? loadingLabel : undefined}
      onClick={onClick}
      title={title || undefined}
    >
      {loading ? (
        <span className={BUTTON_SPINNER_CLASS} aria-hidden="true" />
      ) : icon ? (
        <span className={BUTTON_ICON_CLASS} aria-hidden="true">{icon}</span>
      ) : null}
      <span className={BUTTON_LABEL_CLASS}>{loading ? loadingLabel : children}</span>
    </button>
  );
}

Button.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  // Envoie un `<form>` situé ailleurs dans la page (pied de fenêtre, barre collante).
  form: PropTypes.string,
  icon: PropTypes.node,
  intent: PropTypes.oneOf(INTENTS),
  loading: PropTypes.bool,
  loadingLabel: PropTypes.string,
  onClick: PropTypes.func,
  // Infobulle : précise ce que fait un libellé court (« ⇄ Suivre un autre groupe »).
  title: PropTypes.string,
  type: PropTypes.oneOf(["button", "submit", "reset"]),
};
